import PageMappersFactory from '../../page/Mappers/factory.js'
import AdvertisingValueObjectsFactory from '../ValueObjects/factory.js'
import AdvertisingAdsDetailGalleryValueObjectMapper from './AdvertisingAdsDetailGalleryValueObjectMapper.js'
import AdvertisingAdsDetailValueObjectMapper from './AdvertisingAdsDetailValueObjectMapper.js'
import AdvertisingAdsListValueObjectMapper from './AdvertisingAdsListValueObjectMapper.js'
import AdvertisingGenericValueObjectMapper from './AdvertisingGenericValueObjectMapper.js'
import AdvertisingNewsDetailValueObjectMapper from './AdvertisingNewsDetailValueObjectMapper.js'
import AdvertisingNewsListValueObjectMapper from './AdvertisingNewsListValueObjectMapper.js'
import FromAdvertisingValueObjectToAdvertisingPageDataValueObjectMapper from './FromAdvertisingValueObjectToAdvertisingPageDataValueObjectMapper.js'
import FromRawDataToAdvertisingValueObjectMapper from './FromRawDataToAdvertisingValueObjectMapper.js'
import FromTechnicalDetailsPageDataToAdvertisingValueObjectMapper from './FromTechnicalDetailsPageDataToAdvertisingValueObjectMapper.js'

export default class AdsMappersFactory {
  static fromRawdataToAdvertisingValueObjectMapper = ({config}) =>
    new FromRawDataToAdvertisingValueObjectMapper({
      config,
      advertisingAdsListMapper: new AdvertisingAdsListValueObjectMapper({
        config,
        valueObjectFactory: AdvertisingValueObjectsFactory.advertisingValueObject
      }),
      advertisingAdsDetailMapper: new AdvertisingAdsDetailValueObjectMapper({
        config,
        valueObjectFactory: AdvertisingValueObjectsFactory.advertisingValueObject
      }),
      advertisingAdsDetailGalleryMapper: new AdvertisingAdsDetailGalleryValueObjectMapper({
        config,
        valueObjectFactory: AdvertisingValueObjectsFactory.advertisingValueObject
      }),
      advertisingNewsListMapper: new AdvertisingNewsListValueObjectMapper({
        config,
        valueObjectFactory: AdvertisingValueObjectsFactory.advertisingValueObject
      }),
      advertisingNewsDetailMapper: new AdvertisingNewsDetailValueObjectMapper({
        config,
        valueObjectFactory: AdvertisingValueObjectsFactory.advertisingValueObject
      }),
      advertisingGenericMapper: new AdvertisingGenericValueObjectMapper({
        config,
        valueObjectFactory: AdvertisingValueObjectsFactory.advertisingValueObject,
        fromPageNameToConstantNamingPageName: PageMappersFactory.fromPageNameToConstantNamingPageName()
      }),
      fromTechnicalDetailsPageDataToAdvertisingValueObjectMapper:
        new FromTechnicalDetailsPageDataToAdvertisingValueObjectMapper({
          config,
          fromPageNameToConstantNamingPageName: PageMappersFactory.fromPageNameToConstantNamingPageName(),
          valueObjectFactory: AdvertisingValueObjectsFactory.advertisingValueObject
        })
    })

  static fromAdvertisingValueObjectToAdvertisingPageDataValueObjectMapper = ({config}) =>
    new FromAdvertisingValueObjectToAdvertisingPageDataValueObjectMapper({
      config,
      advertisingPageDataValueObjectFactory: AdvertisingValueObjectsFactory.advertisingPageDataValueObject
    })
}
